// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-body[data-v-0ceac368] {\n  height: auto;\n  overflow-y: scroll;\n  max-height: calc(100vh - 200px);\n}\n.vue-input-tag-wrapper .input-tag[data-v-0ceac368] {\n  margin-bottom: 0px;\n}\n.vue-input-tag-wrapper[data-v-0ceac368] {\n  padding: 0px 10px;\n}\n.vue-input-tag-wrapper .new-tag[data-v-0ceac368] {\n  border-radius: 15px;\n}\n.vue-input-tag-wrapper .input-tag[data-v-0ceac368] {\n  margin-bottom: 0px;\n}", ""]);
// Exports
module.exports = exports;
